// import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
// import Home from "./pages/Home";
// import Profile from "./pages/Profile";
// import Layout from "./pages/Layout";
import Login from "./pages/Login";
import AddMaintenance from "./pages/AddMaintenance";
// import SchoolDashboard from "./pages/SchoolDashboard";
import Salary from "./pages/Salary";
import { useSelector } from "react-redux";
import Layout from "./pages/Layout";
import Teacherreserve from "./pages/Teacherreserve";
import Settings from "./pages/Settings";
import AddPermissions from "./pages/AddPermissions";
import HomeDashboard from "./pages/HomeDashboard";
import AllFinance from "./pages/AllFinance";
import AllExpenses from "./pages/AllExpenses";
import AddAllExpenses from "./pages/AddAllExpenses";
import ExceptionsExpenses from "./pages/ExceptionsExpenses";
import AddExceptionsExpenses from "./pages/AddExceptionsExpenses";
import EditeExceptionsExpenses from "./pages/EditeExceptionsExpenses";
import Maintenance from "./pages/Maintenance";
import Purchases from "./pages/Purchases";
import SignupAsStudent from "./pages/SignupAsStudent";
import StudentDashboard from "./pages/StudentDashboard";
import TimeTable from "./pages/TimeTable";
import AttendanceHistory from "./pages/AttendanceHistory";
import StudentFinance from "./pages/StudentFinance";
import Salaries from "./pages/Salaries";
import Finance from "./pages/Finance";
import AddSalaries from "./pages/AddSalaries";
import AddPurchases from "./pages/AddPurchases";
import Notifications from "./pages/Notifications";
import Payment from "./pages/Payment";
import Forms from "./pages/Forms";
import EditeProfile from "./pages/EditeProfile";
import ChangePassword from "./pages/ChangePassword";
import ChooseStage from "./pages/ChooseStage";
import RegistrationConditions from "./pages/RegistrationConditions";
import PublicAllExpenses from "./pages/PublicAllExpenses";
import AddEmployee from "./pages/AddEmployee";
import Home from "./pages/Home";
import TestPdf from "./pages/TestPdf";
import Contactus from "./pages/Contactus"; 
import Aboutus from "./pages/Aboutus"; 
import RegisterationStudent from "./pages/RegisterationStudent";
import ForgetPassword from "./pages/ForgetPassword";
import Permissions from "./pages/Permissions";
import Students from "./pages/Students";
import EditSalaries from "./pages/EditSalaries";
import Student from "./pages/Student";
import SchoolSettings from "./pages/SchoolSettings";
import AdminStudentFinance from "./pages/AdminStudentFinance";
import StudentsExpenses from "./pages/StudentsExpenses";
import EditeStudent from "./pages/EditeStudent";
import StudentsSchoolExpenses from "./pages/StudentsSchoolExpenses";
import SchoolStructureStages from "./pages/SchoolStructureStages";
import SchoolStructureGrades from "./pages/SchoolStructureGrades";
import MarkAttendance from "./pages/MarkAttendance";
import Transport from "./pages/Transport";
import Illnesses from "./pages/Illnesses";
import Classes from "./pages/Classes";
function MainRoute() {
  // const userinfo = useSelector((state) => state.auth?.userArray?.user);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact-us" element={<Contactus />} />
      <Route path="/about-us" element={<Aboutus />} />
      <Route path="/choose-stage" element={<ChooseStage />} />
      <Route path="/student/:id" element={<RegisterationStudent />} />
              <Route path="/expenses" element={<PublicAllExpenses/>} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignupAsStudent />} />
      <Route path="/registration-conditions" element={<RegistrationConditions />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment/:id/:gradId" element={<Payment />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/dashboard/student/:id" element={<Student />} />
              {/* <Route path="/test" element={<Test/>} /> */}

      {/* <Route path="/notfound" element={<Error/>} /> */}
      <Route path="/dashboard" element={<Layout />}>
                <Route index
          element={
                    localStorage.getItem("type") === "student" ? (
              <StudentDashboard />
            ) : (
              <Login /> // Redirect to login if role is undefined
            )
          } />

        <Route path="/dashboard/Dashboard" element={<HomeDashboard />} />
        <Route path="/dashboard/teacherreserve" element={<Teacherreserve />} />
              <Route path="/dashboard/notifications" element={<Notifications />} />
        <Route path="/dashboard/mark-attendance" element={<MarkAttendance/>} />

        <Route path="/dashboard/employee" element={<Settings />} />
        <Route path="/dashboard/permissions" element={<Permissions />} />
        <Route path="/dashboard/employee/add" element={<AddEmployee />} />
        <Route path="/dashboard/edite-employe/:id" element={<AddEmployee />} />
        <Route path="/dashboard/edite-permission/:id" element={<AddPermissions />} />
        <Route path="/dashboard/permissions/add" element={<AddPermissions />} />
        <Route path="/dashboard/salaries/edite/:id" element={<EditSalaries />} />

        <Route path="/dashboard/students/info" element={<Students />} />
        <Route path="/dashboard/students/illnesses" element={<Illnesses />} />
        <Route path="/dashboard/classes" element={<Classes />} />
        {/* <Route path="/dashboard/students/expenses" element={<StudentsExpenses />} /> */}
        <Route path="/dashboard/students/expenses" element={<StudentsSchoolExpenses />} />
        <Route path="/dashboard/finance/all" element={<AllFinance />} />
        <Route path="/dashboard/expenses/all" element={<AllExpenses/>} />
        <Route path="/dashboard/expenses/exceptions" element={<ExceptionsExpenses/>} />
        <Route path="/dashboard/expenses/exceptions/:id" element={<ExceptionsExpenses/>} />
        <Route path="/dashboard/expenses/all/add" element={<AddAllExpenses/>} />
        <Route path="/dashboard/edite/:id" element={<AddAllExpenses/>} />
        <Route path="/dashboard/expenses/exceptions/add" element={<AddExceptionsExpenses/>} />
        <Route path="/dashboard/expenses/exceptions/add/:id" element={<AddExceptionsExpenses/>} />
        <Route path="/dashboard/expenses/exceptions/:exId/edite/:id" element={<EditeExceptionsExpenses/>} />
        <Route path="/dashboard/maintenance" element={<Maintenance/>} />
        <Route path="/dashboard/Purchases" element={<Purchases/>} />
        <Route path="/dashboard/TimeTable" element={<TimeTable/>} />
        <Route path="/dashboard/AttendanceHistory" element={<AttendanceHistory/>} />
        <Route path="/dashboard/student/Finance" element={<StudentFinance/>} />
        <Route path="/dashboard/student/Finance/:id" element={<AdminStudentFinance/>} />
        <Route path="/dashboard/student/Finance/:id/:gradId" element={<AdminStudentFinance/>} />
        <Route path="/dashboard/forms" element={<Forms/>} />
        <Route path="/dashboard/salaries" element={<Salaries/>} />
        <Route path="/dashboard/admin/Salary/:id" element={<Salary/>} />
        <Route path="/dashboard/admin/Salary/:id" element={<Salary/>} />
        <Route path="/dashboard/finance" element={<Finance/>} />
        <Route path="/dashboard/students/transport" element={<Transport/>} />
        <Route path="/dashboard/maintenance/add" element={<AddMaintenance/>} />
                <Route path="/dashboard/attendance-history" element={<AttendanceHistory/>} />

        <Route path="/dashboard/TestPdf" element={<TestPdf/>} />
        <Route path="/dashboard/purchases/edite/:id" element={<AddPurchases/>} />
        <Route path="/dashboard/maintenances/edite/:id" element={<AddMaintenance/>} />
        <Route path="/dashboard/salaries/add" element={<AddSalaries/>} />
        <Route path="/dashboard/purchases/add" element={<AddPurchases/>} />
        <Route path="/dashboard/change-password" element={<ChangePassword/>} />
            <Route path="/dashboard/profile" element={<EditeProfile/>} />
            <Route path="/dashboard/edit/student/:id" element={<EditeStudent/>} />
                    <Route path="/dashboard/school-settings" element={<SchoolSettings/>} />
        <Route path="/dashboard/structure/stages" element={<SchoolStructureStages />} />
        <Route path="/dashboard/structure/grades" element={<SchoolStructureGrades />} />

    </Route>




    </Routes>


  )
}

export default MainRoute
